/** Раздел словаря «lobby»: лобби (ui/Lobby.tsx), ожидание игроков (ui/WaitingRoom.tsx), правила (ui/Rules.tsx). */
export const lobby = {
  // ── лобби ──
  balance: 'Баланс',
  atTables: 'За столами',
  openTables: 'Открыто столов',
  rulesBtn: 'Правила и расчёт выигрыша',

  // ── ход розыгрыша (лобби и ожидание) ──
  flowTitle: 'Как проходит розыгрыш',
  'flow.prep': 'Подготовка',
  'flow.prepTextAnte': 'взнос {ante|cr} в банк, хеш состава опубликован',
  'flow.round1': 'Круг 1 · график',
  'flow.round1Text': 'без шкалы цен; выбор направления',
  'flow.round2': 'Круг 2 · шкала',
  'flow.round2TextWr': 'цены и пункты; направление можно сменить',
  'flow.round3': 'Круг 3 · состав',
  'flow.round3TextWr': 'три акции раскрыты; только число пунктов',
  'flow.target': 'Целевая свеча',
  'flow.targetText': 'P₁ — закрытие следующей минуты',
  'flow.settleWr': 'Расчёт',
  'flow.settleTextWr': 'выигрывают угадавшие направление; доля — по точности',

  // ── категория столов ──
  'cat.n10': 'Начальный',
  'cat.n50': 'Стандартный',
  'cat.n200': 'Высокий',
  notEnough: 'Недостаточно кредитов для взноса.',

  // ── строка стола ──
  'room.playing': 'идёт розыгрыш',
  'room.startIn': 'старт через {n} с',
  'room.settling': 'расчёт',
  'room.ready': 'готовы {ready} из {min}',
  'room.taken': 'занято {seated} из {max}',
  'room.open': 'Открыть',
  'room.watch': 'Смотреть',

  // ── ожидание игроков ──
  'wr.startIn': 'Розыгрыш начнётся через {n} с',
  'wr.waitMore': 'Ждём ещё {n} подтверждение|Ждём ещё {n} подтверждения|Ждём ещё {n} подтверждений',
  'wr.allReady': 'Все готовы',
  'wr.preparing': 'Подготовка следующего розыгрыша',
  'wr.summary': 'Стол {ante|cr} · {min}–{max} игроков · за столом {seated}, готовы {ready}',
  'wr.botsNote': 'Если людей не хватит, стол доберут боты (они помечены).',
  'wr.spectating': 'Вы наблюдаете за столом.',
  'wr.confirmed': '✓ Участие подтверждено.',
  'wr.anteOnStart': 'Взнос {ante|cr} спишется при старте.',
  'wr.cancel': 'Отменить участие',
  'wr.join': 'Участвовать · взнос {ante|cr}',
  'wr.yourBalance': 'Ваш баланс {amount|cr}',
  'wr.seats': 'Места за столом',
  'wr.you': 'вы',
  'wr.gamesCount': 'розыгрышей: {n}',
  'wr.winRateShort': 'WR',
  'wr.offline': 'нет связи',
  'wr.ready': 'готов',
  'wr.waiting': 'ожидает',
  'wr.free': 'свободно',

  // ── правила ──
  'rules.title': 'Правила «Рыночного стола»',
  'rules.demo': 'Демо с игровыми кредитами. Реальных денег, платежей, покупки или вывода кредитов нет. Не является торговой рекомендацией.',
  'rules.indexTitle': 'Игровой индекс',
  'rules.indexText':
    'Перед каждым розыгрышем сервер случайно выбирает три разные акции из открытого набора ликвидных акций S&P 500. Индекс — равновзвешенная комбинация их процентных изменений относительно закрытия бара P₀:',
  'rules.index1': 'Bᵢ — цена закрытия акции на баре P₀; шаг цены {tick} пункта; округление к ближайшему шагу, половина — вверх.',
  'rules.index2': 'O/C бара — индекс по открытиям/закрытиям; H/L — по максимумам/минимумам компонентов (оценка сверху/снизу), но не уже O и C.',
  'rules.index3': 'Минута без сделок по акции — используется её последняя цена.',
  'rules.index4': '«Активность» — средний по трём акциям объём минуты, делённый на средний объём акции в окне истории (1 = обычно). VWAP* взвешен по активности.',
  'rules.index5': 'Формула открыта; скрыт только состав тройки — до третьего круга. Хеш-обязательство публикуется до ставок и раскрывается после расчёта.',
  'rules.flowTitle': 'Ход розыгрыша',
  'rules.flow1': 'Взнос N вносится в банк, фиксируется P₀.',
  'rules.flow2': 'Круг 1: график без шкалы, выбор направления (выше/ниже) и ставки.',
  'rules.flow3': 'Круг 2: открывается шкала цен и расстояний в пунктах. Направление можно оставить или изменить.',
  'rules.flow4': 'Круг 3: открывается состав. Направление уже не меняется — укажите строго положительное число пунктов (шаг {tick}).',
  'rules.flow5': 'Фиксация. P₁ — закрытие следующей минутной свечи; Δ = P₁ − P₀.',
  'rules.actionsTitle': 'Действия',
  'rules.actionsText':
    'Пас, чек, ставка, колл, райз (не более одного повышения после первой ставки в круге), олл-ин (с побочными банками). Время на ход — {s} с; по тайм-ауту — чек, если возможно, иначе пас. В конце круга пасует только тот, у кого истекло время хода. Кто не успел получить ход, остаётся в игре: неуравнённая часть ставки возвращается. Без полного прогноза к фиксации участник выбывает.',
  'rules.payoutTitle': 'Победители и выплаты',
  'rules.payout1': 'Неверное направление — всегда проигрыш, даже при точном числе пунктов.',
  'rules.payout2':
    'Для угадавших: ошибка = |прогноз − |Δ||; вес = вклад_в_банк / (1 + ошибка / {tick}). Банк делится пропорционально весам; остатки 0,01 кр. — методом наибольших остатков, при равенстве — по порядку хода.',
  'rules.payout3': 'Каждый побочный банк рассчитывается отдельно; на него претендуют только внёсшие в него и не спасовавшие. Банк, где нет угадавших, возвращается внёсшим.',
  'rules.payout4': 'Отмена с полным возвратом и нулевой комиссией: P₁ = P₀; никто из оставшихся не угадал направление; нет достоверных данных.',
  'rules.payout5': 'Все, кроме одного, спасовали — оставшийся забирает банк без проверки прогноза.',
  'rules.exampleTitle': 'Пример',
  'rules.exampleText':
    'Четыре игрока, взнос 10 кр.; Δ = +2,00. Игрок A: «выше 2,00» (ошибка 0, вес 10), B: «выше 2,25» (ошибка 0,25 = 1 шаг, вес 10/2 = 5), C и D — «ниже». Банк 40 кр., комиссия 5% = 2 кр.; к распределению 38 кр.: A — 25,33 кр., B — 12,67 кр.',
  'rules.commissionTitle': 'Комиссия',
  'rules.commissionText':
    '{pct}% от новых кредитов, внесённых в банк в каждом круге (в первом — вместе со взносами). Ранее внесённое и возвращённое не облагается; при отмене комиссия не удерживается.',
  'rules.capOne': 'один взнос',
  'rules.capMany': '{n} взнос|{n} взноса|{n} взносов',
  'rules.cap': 'Потолок — {antes} N за круг, то есть не более {max}N за розыгрыш (как потолок рейка в покере).',
  'rules.retained': 'Удержанное поступает на отдельный счёт банка демо.',
  'rules.hotkeysTitle': 'Горячие клавиши',
  'rules.hotkeys': '↑/↓ направление · +/− пункты (Shift ×4) · F пас · C чек/колл · B ставка/райз · A олл-ин · Enter подтвердить · Esc отмена',
  // ── режимы игры (0.8.0) ──
  'pickTitle': 'Выбор игры',
  'pickIntro': 'Два режима — два характера. Выберите режим и стол: за столом от 4 до 8 игроков, розыгрыш длится три минуты.',
  'variant.blind3.title': 'Слепая тройка',
  'variant.blind3.tag': '3 из 500',
  'variant.blind3.text': 'Три случайные акции S&P 500, имена скрыты до последнего круга. Внешние инструменты анализа не помогут: все за столом в равных условиях, решают чтение графика и выдержка.',
  'variant.blind3.badge': 'на равных',
  'variant.blind3.f1': 'состав скрыт до круга 3',
  'variant.blind3.f2': 'направление — в кругах 1–2',
  'variant.spx.title': 'Открытые карты',
  'variant.spx.tag': 'S&P 500',
  'variant.spx.text': 'Инструмент известен заранее, настоящая цена видна с первой секунды. Используйте весь свой анализ и собственные инструменты. Режим для уверенных в себе.',
  'variant.spx.badge': 'для уверенных',
  'variant.spx.f1': 'инструмент {symbol}, цена видна сразу',
  'variant.spx.f2': 'направление — только в круге 1',
  'variant.spx.demoNote': 'Демо: котировки фонда SPY за случайный момент прошлых дней.',
  'tier.ante': 'взнос',
  'tier.seated': 'за столами: {n}',
  'tier.empty': 'свободно',
  'tier.mine': 'вы здесь',
  'tier.aria': 'Сесть за стол {ante|cr} · {variant}',
  'chooseTable': 'Выберите стол',
  'liveTitle': 'Столы сейчас',
  'liveEmpty': 'Пока ни за одним столом не играют — выберите режим и стол выше.',
  'flow.open.prepText': 'взнос {ante|cr} в банк; инструмент и цена видны сразу',
  'flow.open.round1': 'Круг 1 · направление',
  'flow.open.round1Text': 'выбор направления; после круга оно не меняется',
  'flow.open.round2': 'Круг 2 · пункты',
  'flow.open.round2Text': 'только число пунктов',
  'flow.open.round3': 'Круг 3 · пункты',
  'flow.open.round3Text': 'последнее уточнение числа пунктов',
  'rules.variantsTitle': 'Режимы игры',
  'rules.variantBlind3': '«Слепая тройка» (3 из 500): индекс из трёх случайных акций, шкала цен скрыта до круга 2, состав — до круга 3. Направление выбирается в подготовке и кругах 1–2.',
  'rules.variantSpx': '«Открытые карты» (S&P 500): известный инструмент и его настоящая цена в долларах с шагом 0,01; график и цена видны с начала. Направление выбирается в подготовке и круге 1, в кругах 2–3 меняется только число пунктов (1 пункт = 1 $). В демо — фонд SPY за случайный момент прошлых дней. Ставки, комиссия и расчёт — общие для обоих режимов.',
  // ── режимы игры (0.8.0) ──
  // ── подпись «демо» и карточки «скоро» (0.8.1) ──
  'variant.demo': 'демо',
  'soon.label': 'скоро',
  'soon.sub': 'на доллары · скоро',
  'soon.tier': 'скоро',
  'soon.toast': 'Столы на доллары скоро будут.',
  'soon.aria': 'Стол {amount} $ · {variant} — скоро',
};
